<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fm-title"><a id="page_xviii"></a>HOW TO USE THIS BOOK</h2>
<p class="noindent"><span class="drop-cap">T</span>his book is, as mentioned, set out in a way that you can look for the shape of the badge, rather than a name you have no idea of.</p>
<p class="indent">First, look for what you can see. Does it have a crown on top of it? Can you see wings, or something else?</p>
<p class="indent">The contents page lists the badges by feature in their chapters so once you’ve identified one of the prominent features, use the contents list to find the right section. Please note that if you see more than one thing, it will be listed under that section too, so you can easily cross-reference.</p>
<p class="indent">Sadly, some photos you may find are either too poor in quality or they have been played around with, so you can’t see anything much at all. The modern culprits for this are photocopies of originals and, sadly, poor restorations of photos by misguided amateurs who don’t have the facilities Peter Jackson did when he made his First World War film in colour a couple of years ago. Pixelation is totally lost by the smudging process, and 99 times out of 100, the amateur colouring-in enthusiast doesn’t research what the colours of the uniforms actually are. Thus you end up with something that is neither accurate nor legible anymore. This could well be handed down to subsequent generations as ‘how it was’ when it wasn’t.</p>
<p class="indent">Always, always look at an original photo if possible. If that isn’t available, ask the relative for a high resolution scan. Some of these old photos are so good, you can often make out what is actually on the buttons. The late Victorian/early Edwardian ‘cabinet’ photos are very good for this.</p>
<p class="indent">As always, the devil is in the detail, and the more detail you can see, the better. It is also best practice to have a scanner or a magnifying glass available alongside this book and the original photo – or a high resolution scan of it!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_Fm06.vue?0e2de90c